export const buildStackDataKey = <T extends Record<string, any> & object>(
  dataKey: string,
  keysToCheckMaximum: string[],
  data: T[]
) => {
  let maxOfMaximum = 0;
  let isNegative = false;

  keysToCheckMaximum.forEach((key) => {
    const max = data.reduce((acc, item) => {
      const value = Math.abs(item[key]);

      if (item[dataKey] < 0) {
        isNegative = true;
      }

      return value > acc ? value : acc;
    }, 0);

    if (max > maxOfMaximum) {
      maxOfMaximum = max;
    }
  });

  return data.map((item) => {
    let maxStackValue = maxOfMaximum - item[dataKey];

    if (isNegative) {
      maxStackValue = -maxStackValue;
    }

    return {
      ...item,
      [`${dataKey}Stack`]: maxStackValue,
    };
  });
};
